<template>
  <div>
    <b-navbar
      type="dark"
      variant="dark"
      class="mb-5"
      toggleable="lg"
      fixed="top"
    >
      <b-navbar-brand
        >{{ $t("comp-admin-menu.brand") }}
        {{ mode === "staging" ? "STAGING" : "" }}
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav v-if="isLogedin">
          <b-nav-item
            to="/accounts"
            :active="$route.name === 'accounts'"
            v-if="$loginData.hasRole('user')"
            >{{ $t("comp-admin-menu.accounts") }}</b-nav-item
          >
          <b-nav-item to="/users" :active="$route.name === 'users'">
            Users
          </b-nav-item>

          <b-nav-item-dropdown>
            <template #button-content>
              {{ $t("comp-admin-menu.master-data") }}
            </template>
            <b-dropdown-item to="/creditor">{{
              $t("comp-admin-menu.vendor")
            }}</b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item to="/goodgroups">{{
              $t("comp-admin-menu.goods-groups")
            }}</b-dropdown-item>
            <b-dropdown-item to="/goods">{{
              $t("comp-admin-menu.goods")
            }}</b-dropdown-item>
            <b-dropdown-item to="/products">{{
              $t("comp-admin-menu.products")
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown>
            <template #button-content>{{
              $t("comp-admin-menu.settings")
            }}</template>
            <!--<b-dropdown-item to="/general-settings">{{$t("comp-admin-menu.general-settings")}}</b-dropdown-item>-->
            <!--<b-dropdown-divider />-->
            <b-dropdown-item to="/dashboard-content">{{
              $t("comp-admin-menu.dashboard")
            }}</b-dropdown-item>
            <b-dropdown-item to="/projectnotification">
              Create project notification
            </b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item to="/serverdownloads">{{
              $t("comp-admin-menu.server-management")
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown>
            <template #button-content>{{
              $t("comp-admin-menu.templates")
            }}</template>
            <b-dropdown-item to="/fonts">{{
              $t("comp-admin-menu.fonts-configuration")
            }}</b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item to="/imagemanagement">{{
              $t("comp-admin-menu.image-configuration")
            }}</b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item to="/templatemanagment">{{
              $t("comp-admin-menu.template-configuration")
            }}</b-dropdown-item>
            <b-dropdown-item to="/templateconf">{{
              $t("comp-admin-menu.template-conf")
            }}</b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item to="/manualresult">{{
              $t("comp-admin-menu.manual-results")
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown>
            <template #button-content>{{
              $t("comp-admin-menu.events")
            }}</template>
            <b-dropdown-item to="/events">{{
              $t("comp-admin-menu.raw-events")
            }}</b-dropdown-item>
            <b-dropdown-item to="/logins">{{
              $t("comp-admin-menu.logins")
            }}</b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item to="/event">{{
              $t("comp-admin-menu.event-editor")
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown>
            <template #button-content>{{
              $t("comp-admin-menu.extras")
            }}</template>
            <b-dropdown-item to="/packlists">{{
              $t("comp-admin-menu.packlists")
            }}</b-dropdown-item>
            <b-dropdown-item to="/notconfirmed">{{
              $t("comp-admin-menu.notconfirmed")
            }}</b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item to="/unpaidinvoices"
              >Unpaid invoices</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item @click="logout" v-if="isLogedin">{{
            $t("comp-menu.menu-logout")
          }}</b-nav-item>
          <comp-language-selector :nav="true" v-if="!hideLanguageSelector" />
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-breadcrumb class="breadcrumb" v-if="isLogedin">
      <b-breadcrumb-item>
        {{ $loginData.data.firstname }} {{ $loginData.data.lastname }}
      </b-breadcrumb-item>
      <b-breadcrumb-item>
        {{ $loginData.data.id }}
      </b-breadcrumb-item>
      <b-breadcrumb-item
        >{{ $selectedAccount.data.companyName }} [{{
          $selectedAccount.data.id
        }}]</b-breadcrumb-item
      >
    </b-breadcrumb>
  </div>
</template>

<script>
import CompLanguageSelector from "../components/CompLangaugeSelector";
import { defaults } from "../assets/config";

export default {
  name: "CompMenu",
  components: {
    CompLanguageSelector,
  },
  data() {
    return {
      isLogedin: false,
      mode: defaults.mode,
      hideLanguageSelector: defaults.hideLanguageSelector,
    };
  },
  methods: {
    logout() {
      this.isLogedin = false;
      this.$loginData.data = null;
      this.$selectedAccount.data = undefined;
      this.$eventBus.$emit("account-changed");
      this.$router.push("/");
    },
  },
  created() {
    this.$eventBus.$on("login", () => {
      this.isLogedin = typeof this.$loginData.data !== "undefined";
    });
    this.$eventBus.$on("account-changed", () => {
      this.$forceUpdate();
    });
    this.$eventBus.$on("logout", () => {
      this.logout();
    });
  },
};
</script>
